import type { TTipoProdutoChileEnum, TTipoProdutoPrecificadoBrasilEnum } from './produto'

export const SimulacaoStatusEnum = {
  Gerada: 'Gerada',
  Enviada: 'Enviada',
  Vencida: 'Vencida',
} as const
export type TSimulacaoStatusEnum = keyof typeof SimulacaoStatusEnum

export type TSimulacaoStatusChileEnum = Exclude<TSimulacaoStatusEnum, 'Gerada'>

export const SimulacaoSituacaoEnum = {
  Pendente: 'Pendente',
  Descartada: 'Descartada',
  Salva: 'Salva',
} as const
export type TSimulacaoSituacaoEnum = keyof typeof SimulacaoSituacaoEnum

export const PeriodicidadePagamentoEnum = {
  Anual: 'Anual',
  Semestral: 'Semestral',
  Trimestral: 'Trimestral',
  Bimestral: 'Bimestral',
  SemPeriodoFixo: 'SemPeriodoFixo',
} as const
export type TPeriodicidadePagamentoEnum = keyof typeof PeriodicidadePagamentoEnum

export const FormaDePagamentoEnum = {
  Saldo: 'Saldo',
  Parcelado: 'Parcelado',
} as const
export type TFormaDePagamentoEnum = keyof typeof FormaDePagamentoEnum

export type TParcela = { data: string; valor: number }

export type TGrupoParcelas = {
  parcelas: TParcela[]
}

export type TGrupoParcelasIntermediarias = {
  parcelas: TParcela[]
  periodicidade: TPeriodicidadePagamentoEnum
}
export type TEmpreendimentoSimulacao = {
  idExterno: number
  nome: string
}

export type TAcessoriosDaUnidade = Array<{
  nome: string
  acessorios: Array<{
    idExterno: number
    nome: string
    metragem: string
  }>
}>

export const TipoAmortizacaoEnum = {
  SacocV: 'SacocV',
  SacocH: 'SacocH',
  Price: 'Price',
} as const
export type TTipoAmortizacaoEnum = keyof typeof TipoAmortizacaoEnum | null

export const ModoDeLucroDaEmpresaEnum = {
  IsencaoIRPJ: 'IsencaoIRPJ',
  Presumido: 'Presumido',
  RealEstimado: 'RealEstimado',
} as const
export type TModoDeLucroDaEmpresa = keyof typeof ModoDeLucroDaEmpresaEnum

export interface ImobiliariasCorretores {
  id: string
  imobiliariaCorretorId: string
  percentualCorretagem: number
  valorCorretagem: number
}

export interface TTabelaDePrecoProduto {
  id: string
  versao: number
  valorBase: number
  custoEmUPF: number
  valorBaseAto: number
  valorBaseSinal: number
  valorBaseMensais: number
  valorBaseIntermediarias: number
  valorBaseSaldo: number
  percentualMargem: number
  margemVendedor1Por3: number
  margemVendedor2Por3: number
  margemVendedor3Por3: number
  margemGcom: number
  margemGR: number
  imobiliariasCorretores?: ImobiliariasCorretores[]
  percentualJurosAnualPrice: number | null
  valorMinimoLote: number | null
  valorAVistaGcom?: number | null
  valorAVistaGr?: number | null
  valorAVistaVendedor?: number | null
}

export interface TCondicoesDePrecoProduto {
  id: string
  versao: number
  percentualISS: number
  percentualImpostos: number
  percentualIRPJ: number
  percentualINCC?: number | null
  dataPontoMedio: string
  modoDeLucroDaEmpresa: TModoDeLucroDaEmpresa
  dataSaldo: string
  dataAto: string
  dataSinal1: string
  dataSinal2: string | null
  dataSinal3: string | null
  dataSinal4: string | null
  dataPrimeiraMensal: string
  dataUltimaMensal: string
  dataDasIntermediarias: string[]
  previsaoDeEntregaDoBloco: string
  percentualComissaoVendedor: number
  patrimonioAfetacao: boolean
  quantidadeMensais?: number
  percentualJurosAnualAntesPontoMedio: number
  percentualJurosAnualDepoisPontoMedio: number
  percentualAutonomiaVendedorSobrePoupanca1Por3: number
  percentualAutonomiaVendedorSobrePoupanca2Por3: number
  tipoDeAmortizacao: TTipoAmortizacaoEnum | null
  totalDeMesesDoParcelamentoDeMensais?: number | null
  prazoSemCorrecao?: number
  opcoesDeParcelamentoPrice?: number[] | null
  percentualAto: number | null
  percentualSinal: number | null
  percentualMensais: number | null
  percentualIntermediarias: number | null
  prazoDeParcelamentoComIntermediarias: boolean | null
}

export type TGetSimulacaoResponse = {
  id: string
  status: TSimulacaoStatusEnum
  situacao: TSimulacaoSituacaoEnum
  empreendimento: TEmpreendimentoSimulacao
  dataSimulacao: string
  atendimentoId: string
  oportunidade?: {
    codigoOportunidade: string
    imobiliaria: string
  } | null
  cliente: {
    id: string
    vendedorAlocadoId: string | null
    nome: string
    cpf: string | null
  }
  vendedor?: {
    id?: string
    nome?: string
  } | null
  bloco: {
    idExterno: number
    id: string
    nome: string
    previsaoDeEntrega: string
    condicaoDePrecoId: string
  }
  produto: {
    idExterno: number
    codigo: string
    nome: string
    tabelaDePrecoId: string
    metragemPrivativa: number
    acessorioObrigatorio: boolean
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum | null
    andar?: number | null
    dataMarcacaoAlvenaria: string | null
    plantaId: string | null
    plantaCodigo: number | null
    plantaDescricao: string | null
    acessoriosDaUnidade: TAcessoriosDaUnidade | null
  }
  ato: { data: string; valor: number } | null
  entrada: Array<{ data: string; valor: number }>
  mensais: Array<{ parcelas: Array<{ data: string; valor: number }> }>
  intermediarias: Array<{
    parcelas: Array<{ data: string; valor: number }>
    periodicidade: TPeriodicidadePagamentoEnum
  }>
  saldo: { data: string; valor: number } | null
  posConclusao: Array<{ data: string; valor: number }>
  intermediariasPosConclusao?: Array<{
    parcelas: Array<{ data: string; valor: number }>
    periodicidade: TPeriodicidadePagamentoEnum
  }>
  rotinaArquivo: {
    arquivo: string
    comissaoVendedor: number
    fatorGR: number
    fatorGcom: number
    fatorVendedor1Por3: number | null
    fatorVendedor2Por3: number | null
    fatorVendedor3Por3: number | null
    margemBruta: number
    margemLiquida: number
    percentualMargemVenda: number
    rotina: string
    valorMedioTotal: number
    valorMedioTotalUPF: number
    valorPresente: number
    valorPresentePontoMedio: number
    valorPresentePontoMedioUPF: number
  }
  valorTotalSimulado: number
  valorPoupanca: number
  valorSaldo: number
  valorProposto: number | null
  valorITBI: number | null
  custasCartorarias: number | null
  valorMensalPrice: number | null
  valorIntermediariaPrice: number | null
  prazoEmMeses: number
  tipoDeAmortizacao?: TTipoAmortizacaoEnum
  formaDePagamento?: TFormaDePagamentoEnum
  prazoDeParcelamentoPrice?: number | null
}

export type TGetSimulacaoProdutoResponse = TGetSimulacaoResponse & {
  produto: { tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum }
}

export type TGetSimulacaoPlantaResponse = TGetSimulacaoResponse & {
  produto: { tipoDoProduto: null }
}

export type TGetSimulacaoDuplicarResponse = {
  id: string
  dataSimulacao: string
  tipoDeAmortizacao: TTipoAmortizacaoEnum | null
  empreendimento: TEmpreendimentoSimulacao
  produto: {
    nome: string
    id: string
    idExterno: number
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum | TTipoProdutoChileEnum
  }
  bloco: { id: string; idExterno: number; previsaoDeEntrega: string; nome: string }
  idExternoUnidadeDaPlanta?: number | null
  entrada: TGrupoParcelas['parcelas']
  mensais: TGrupoParcelas[]
  intermediarias: TGrupoParcelasIntermediarias[]
  intermediariasPosConclusao: TGrupoParcelasIntermediarias[] | null
  saldo: TGrupoParcelas['parcelas'][number] | null
  posConclusao: TGrupoParcelas['parcelas']
  formaDePagamento?: TFormaDePagamentoEnum | null
  valorProposto?: number | null
  prazoDeParcelamentoPrice?: number | null
  taxaAplicadaDividendoEstimado: number
}
